export const ADDRESS = 'https://blebber-server.vercel.app';

export const HEADERS = {
  'Content-Type': 'application/json',
  Accept: 'application/json',
};

export const GOOGLE_KEY =
  'AIzaSyCiUrUjp4yCGyUqS9l0olH4wzeoC6QTqjU';
